var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.63253e-07 7.60552L3.16112 4.5L0 1.39448L1.41944 0L6 4.5L1.41944 9L2.63253e-07 7.60552Z"}));
}

ArrowRight.defaultProps = {"width":"6","height":"9","viewBox":"0 0 6 9","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
